<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { cremaApi } from '@/api/entities/review/crema'

definePage({
  meta: {
    title: '크리마 브랜드',
    action: 'read',
    subject: 'review',
  },
})

const { handleError } = useErrorHandler()

// 상태
const loading = ref(false)
const brands = ref<any[]>([])
const page = ref(1)
const itemsPerPage = ref(50)
const totalItems = ref(0)

// 테이블 헤더
const headers = [
  { title: 'ID', key: 'id', sortable: true },
  { title: '브랜드명', key: 'name', sortable: true },
  { title: '코드', key: 'code', sortable: true },
  { title: '상태', key: 'status', sortable: true },
]

// 데이터 로드
const loadBrands = async () => {
  loading.value = true
  try {
    const { success, data, error } = await cremaApi.listCremaBrands(page.value, itemsPerPage.value)

    if (success && data) {
      brands.value = data.data || []
      totalItems.value = data.total || 0
    }
    else if (error) {
      handleError(error, { notificationMessage: '크리마 브랜드 목록을 불러오는데 실패했습니다.' })
    }
  }
  catch (error) {
    handleError(error, { notificationMessage: '크리마 브랜드 목록을 불러오는데 실패했습니다.' })
  }
  finally {
    loading.value = false
  }
}

// 페이지 변경
const onPageChange = (newPage: number) => {
  page.value = newPage
  loadBrands()
}

onMounted(() => {
  loadBrands()
})
</script>

<template>
  <VCard>
    <VCardTitle>크리마 브랜드</VCardTitle>
    <VCardText>
      <VDataTableServer
        v-model:page="page"
        v-model:items-per-page="itemsPerPage"
        :headers="headers"
        :items="brands"
        :items-length="totalItems"
        :loading="loading"
        class="elevation-0"
        @update:page="onPageChange"
      />
    </VCardText>
  </VCard>
</template>
